<template>
    <v-card outlined>
        <v-card-text class="pb-1">
            <v-container class="py-0">
                <v-row class="my-0 py-0">
                    <v-col cols=12 md=6 class=" my-0 py-0">
                        <v-row class="ma-0 pa-0">
                            <v-col class="ma-0 pa-0">
                                <v-list color="transparent" class="ma-0 pa-0">
                                    <v-list-item class="ma-0 pa-0">
                                        <v-list-item-avatar class="my-0 py-0" v-bind:class="{primary: (businessProfile.premiereProfileLogoImageURL || '') ==''}" :style="`background-position: center;background-repeat: no-repeat;background-size: cover;background-size: cover;background-image: url('${businessProfile.premiereProfileLogoImageURL || ''}')`">
                                            <v-icon v-if="(businessProfile.premiereProfileLogoImageURL || '') ==''" dark>person</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content class="my-0 py-0">
                                        <v-list-item-title>{{ businessProfile.businessName }}</v-list-item-title>
                                        <v-list-item-subtitle>
                                            <timeago :datetime="Date.parse(post.createdAt.toDate())" :auto-update="60"></timeago>
                                        </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                {{post.text || ''}}
                            </v-col>
                        </v-row>
                        <v-row v-for="(video, index) in videos" :key="video.url">
                            <v-col>
                                 <d-player
                                    :options="{ video: { url: video.url, pic: ''},}"
                                    :ref="`player-${index}`"
                                    style="border-radius:5px;"    
                                >
                                 </d-player>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                            v-for="(image, index) in images.slice(0,shortenedImagesLength)"
                            :key="image.url"
                            class="d-flex child-flex"
                            :cols="index == 0 && shortenedImagesLength !== 2? 12 : 6"
                            >
                            <v-card elevation="0" @click="presentAssetCarousel(videos.length + index)">
                                <v-img
                                    :src="image.url"
                                    :aspect-ratio="index == 0 && shortenedImagesLength !== 2? null : 1"
                                    class="info rounded"
                                    
                                >
                                    <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                        <v-progress-circular
                                            indeterminate
                                            color="accent"
                                        ></v-progress-circular>
                                    </v-row>
                                    </template>
                                    <v-row
                                        v-if="(index == shortenedImagesLength-1) && (post.assets.length - videos.length - shortenedImagesLength  > 0)"
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                        <v-overlay :value="true" :absolute="true" opacity="0.8">
                                            <p class="text-h3 white--text">+ {{post.assets.length - videos.length - shortenedImagesLength + 1 }}</p>
                                        </v-overlay>
                                    </v-row>
                                </v-img>
                            </v-card>
                            </v-col>
                        </v-row>
                        <LightBox v-if="[...videos, ...images].length !=0" ref="lightbox" :assets="[...videos, ...images]"/>
                         <v-row class="d-block d-md-none">
                            <v-col>
                                <span class="mr-8"><v-icon class="mr-2">thumb_up</v-icon>{{ post.noOfLikes || 0 }}</span>
                                <span><v-icon class="mr-2">comment</v-icon>{{ post.noOfComments || 0 }}</span>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols=12 md=6 class="my-0 py-0">
                        <!-- Start: More Comments Dialog -->
                        <v-dialog eager scrollable width="700" v-model="moreCommentsDialog">
                            <v-card>
                                <v-card-title class="pb-0 mb-n5">
                                    <v-container>
                                     <v-row class="pa-0 ma-0">
                                        <v-col  class="pa-0 ma-0">
                                            <AddCommentTextfield :post="post" />
                                        </v-col>
                                    </v-row>
                                    </v-container>
                                </v-card-title>
                                <v-card-text class="py-0 my-0">
                                    <v-container class="pb-0">
                                         <v-row  ref="topOfTheCommentsDialog" class="ma-0 pa-0">
                                        </v-row>
                                        <v-row class="ma-0 pa-0"  v-for="comment in comments" :key="comment.commentId">
                                            <v-col class="ma-0 pa-0">
                                                <CommentViewer :comment="comment" />
                                            </v-col>
                                        </v-row>
                                        <v-row  v-if="!isCommentListEndReached" class="pb-0 mb-0">
                                            <v-col class="pb-0 mb-0">
                                                <p class="d-flex">
                                                    <v-list color="transparent" class="ma-0 pa-0">
                                                        <v-list-item class="ma-0 pa-0">
                                                            <v-list-item-avatar class="my-0 py-0">
                                                                <v-icon color="white">person</v-icon>
                                                            </v-list-item-avatar>
                                                        </v-list-item>
                                                    </v-list>
                                                    <v-btn :loading="viewMoreCommentsDialogButtonLoading" text color="secondary" @click="loadMoreComments">View More Comments</v-btn>
                                                </p>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-dialog>
                        <!-- End: More Comments Dialog -->
                        <AddCommentTextfield :post="post" />
                        <v-row class="ma-0 pa-0"  v-for="comment in comments.slice(0, shortenedLength)" :key="comment.commentId">
                            <v-col class="ma-0 pa-0">
                                 <CommentViewer :comment="comment" />
                            </v-col>
                        </v-row>
                        <p v-if="comments.length > shortenedLength" class="d-flex">
                            <v-list color="transparent" class="ma-0 pa-0">
                                <v-list-item class="ma-0 pa-0">
                                    <v-list-item-avatar class="my-0 py-0">
                                        <v-icon color="white">person</v-icon>
                                    </v-list-item-avatar>
                                </v-list-item>
                            </v-list>
                            <v-btn :loading="viewMoreCommentsButtonLoading" text color="secondary" @click="presentMoreCommentsDialog">View More Comments</v-btn>
                        </p>
                    </v-col>
                </v-row>
                <v-row class="d-none d-md-block">
                    <v-col>
                        <span class="mr-8"><v-icon class="mr-2">thumb_up</v-icon>{{ post.noOfLikes || 0 }}</span>
                        <span><v-icon class="mr-2">comment</v-icon>{{ post.noOfComments || 0 }}</span>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import CommentViewer from '@/components/CommentViewer'
import AddCommentTextfield from '@/components/AddCommentTextfield'
import VueDPlayer from 'vue-dplayer'
import 'vue-dplayer/dist/vue-dplayer.css'
import LightBox from '@/components/LightBox'
import {where, orderBy} from "firebase/firestore";
import {getQueryByCollectionName} from "@/shared/firebase_utils";

export default {
    name: 'PostViewer',
    props: {
        post: {
            type: Object,
            default: {},
        },
    },
    components: {
        CommentViewer,
        AddCommentTextfield,
        'd-player': VueDPlayer,
        LightBox,
    },
    mounted() {
       this.commentsQuery
        .limit(this.shortenedLength + 1)
        .onSnapshot((querySnapshot) => {
            if(querySnapshot.docs.length == 0) {
                this.isCommentListEndReached = true;
            }
            const changes = querySnapshot.docChanges();
            changes.forEach((change)=> this.handleDocumentChange(change));
        });
    },
    data() {
        return {
            viewMoreCommentsDialogButtonLoading: false,
            viewMoreCommentsButtonLoading: false,
            shortenedLength: 4,
            commentListPageSize: 2,
            moreCommentsDialog: false,
            comments: [],
            isCommentListEndReached: false,
        }
    },
    methods: {
        presentAssetCarousel(index) {
            this.$refs.lightbox.show(index);
        },
        async loadMoreComments() {
            this.viewMoreCommentsDialogButtonLoading = true;
            await this.commentsQuery
            .limit(this.commentListPageSize)
            .startAfter(this.lastLoadedDocumnet)
            .onSnapshot((querySnapshot) => {
                if(querySnapshot.docs.length == 0) {
                    this.isCommentListEndReached = true;
                }
                const changes = querySnapshot.docChanges();
                changes.forEach((change)=> this.handleDocumentChange(change));
            });
            this.viewMoreCommentsDialogButtonLoading = false;
        },
        scrollToTheTop() {
            // document.getElementById('topOfTheCommentsDialog').scrollIntoView();
            this.$refs.topOfTheCommentsDialog.scrollIntoView();
        },
        presentMoreCommentsDialog() {
            this.viewMoreCommentsButtonLoading = true;
            setTimeout(this.scrollToTheTop, 10);
            if (this.comments.length <= this.shortenedLength + 1) {
                this.loadMoreComments();
            }
            this.moreCommentsDialog=true;
            this.viewMoreCommentsButtonLoading = false;
        },
        handleDocumentChange(change) {
            if (change.type === 'added') {
                if(this.comments.length != 0 && change.doc.data({ serverTimestamps: 'estimate' }).createdAt.toDate() > this.comments[0].createdAt.toDate()) {
                    this.comments.unshift({commentId: change.doc.id, ...change.doc.data({ serverTimestamps: 'estimate' })});
                } else{
                    this.comments.push({commentId: change.doc.id, ...change.doc.data({ serverTimestamps: 'estimate' })});
                    this.lastLoadedDocumnet = change.doc;
                }                
            }
            else if (change.type == 'modified') {
                //Replace the old post object within the post array with the modified object
                this.comments.forEach((item, i)=> { 
                    if (item.commentId ==  change.doc.id)  {
                        //Replace the old comment with the new modified comment (Logic to be written here)
                    }
                });
            }
        },
    },
    computed: {
        ...mapGetters(['userProfile', 'businessProfile']),
        commentsQuery() {
            return  getQueryByCollectionName('comments',
                    where('postId','==', this.post.postId),
                    orderBy('createdAt','desc'));
        },
        shortenedImagesLength() {
            if(this.images.length == 1)
                return 1;
            if(this.videos.length > 0 || this.images.length < 3)
                return 2;
            else
                return 3;
        },
        images() {
            return this.post.assets.filter(asset => asset.type == 'image');
        },
        videos() {
            return this.post.assets.filter(asset => asset.type == 'video');
        },
    },
}
</script>
